module.exports = __webpack_public_path__ + "static/media/safeway-card-logo.79465b89.png";